import { render, staticRenderFns } from "./FollowDetail.vue?vue&type=template&id=d0875d2c"
import script from "./FollowDetail.vue?vue&type=script&lang=ts"
export * from "./FollowDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports